import { Box, Typography } from "@mui/material";

export const AmikFooter = () => {
  return (
    <Box
      component="footer"
      sx={{
        mt: 4,
        py: 1,
        pr: 2,
        textAlign: "right",
        borderTop: "1px solid rgba(0, 0, 0, 0.1)",
        backgroundColor: "rgba(0, 0, 0, 0.02)",
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: "text.secondary",
          fontSize: { xs: "0.6rem", sm: "0.65rem" },
          mb: 0.25,
          display: "block",
        }}
      >
        Powered by{" "}
        
          Amik Tech
      </Typography>
      <Typography
        variant="caption"
        sx={{
          color: "text.secondary",
          fontSize: { xs: "0.55rem", sm: "0.6rem" },
          display: "block",
        }}
      >
        © {new Date().getFullYear()} Amik Tech. All Rights Reserved.
      </Typography>
    </Box>
  );
};

